import { Dropdown, Field, Input, Option, useId } from "@fluentui/react-components";
import * as React from "react";
import { getAddressLocalFromUserSelectedRange, getValuesFromUserSelectedRange } from "../../taskpane";
import GetFromXlWsButton from "../Buttons/GetFromXlWsButton";

export type ValidatorFunctionType = CallableFunction & {
  (value: string): {
    state: ValidationStateStr;
    message: string;
  };
};

interface UserInputProps {
  labelDescription: string;
  label: string;
  isRequired: boolean;
  validatorFunction?: ValidatorFunctionType;
  updateValue?: CallableFunction & {
    (
      label: string,
      value: string,
      isValid: boolean,
      message: string,
      validationState: ValidationStateStr
    ): void;
  };
  value: string;
  message: string;
  validationState: ValidationStateStr;
  options?: string[];
  disabled: boolean;
  isButtonHelper: boolean;
  buttonHelperType?: "sum" | "rangePicker";
}

export type ValidationStateStr = "none" | "success" | "error" | "warning";

const UserInput: React.FC<UserInputProps> = (props: UserInputProps) => {
  const handleChange = (_, data) => {
    const value = data.value || data.optionValue;
    if (props.validatorFunction) {
      const result = props.validatorFunction(value);
      if (props.updateValue) {
        props.updateValue(
          props.label,
          value,
          result.state === "success" || result.state === "warning",
          result.message,
          result.state
        );
      }
    }
  };
  const dropdownId = useId("dropdown-default");

    // Handlers
  const handleTargetClick = async () => {
    const values = await getValuesFromUserSelectedRange();
    let sum = 0;
    values.forEach((num) => {
      sum += Number(num);
    });
    sum = Number(sum.toFixed(2));
    if (!isNaN(sum)) {
      props.updateValue?.(props.label, sum.toString(), true, "Value retrieved from selected range", "success");
    }
  };

  const handleRangeClick = async () => {
    const userSelectedAddressLocal = await getAddressLocalFromUserSelectedRange();
    const userReadable = userSelectedAddressLocal.split("!");
    const cellRange = userReadable[userReadable.length - 1];
    props.updateValue?.(props.label, cellRange, true, "Value retrieved from selected range", "success");
  };
  return (
    <div>
      <Field
        // className={props.fieldClassName}
        label={props.labelDescription}
        required={props.isRequired}
        validationState={props.validationState}
        validationMessage={props.message}
        style={{
            whiteSpace: "normal",
            wordBreak: "break-word",
            width: "100%",
            maxWidth: "420px",
        }}
      ></Field>
      {props.options ? (
        <Dropdown
          id={dropdownId}
          placeholder="Select an option"
          // value={props.value}
          onOptionSelect={handleChange}
          disabled={props.disabled}
          style={{
            whiteSpace: "normal",
            wordBreak: "break-word",
            width: "100%",
            maxWidth: "420px",
        }}
        >
          {props.options.map((option) => (
            <Option key={option} value={option}>{option}</Option>
          ))}
        </Dropdown>
      ) : (
        <>
          <Input
            // className={props.inputClassName}
            // id={props.inputId}
            // type={props.inputType}
            // name={props.inputName}
            // contentBefore={props.icon}
            value={props.value}
            onChange={handleChange}
            disabled={props.disabled}
            style={{ width: "100%", maxWidth: "420px" }}
            // step={props.step}
          />
          {props.isButtonHelper && (
            <GetFromXlWsButton
              buttonClassName={"targetValueInputButton"}
              toolTipStr={"Click to get value from selected cell or range"}
              handleClick={handleRangeClick}
            />
          )}
        </>
      )}
    </div>
  );
};

export default UserInput;
